export default {
  labs: {
    label: 'Labs',
    filterTitle: 'Filter by status',
    search: 'Search labs',
    successfullyUpdated: 'Successfully updated',
    successfullyCompleted: 'Successfully completed',
    successfullyCreated: 'Successfully created',
    status: {
      requested: 'Requested',
      completed: 'Completed',
      canceled: 'Canceled',
    },
    filter: {
      all: 'All statuses',
    },
    requests: {
      label: 'Lab Requests',
      new: 'Request Lab',
      save: 'Request',
      view: 'View Lab',
      cancel: 'Cancel Lab',
      complete: 'Complete Lab',
      update: 'Update Lab',
      error: {
        unableToRequest: 'Unable to create new lab request.',
        unableToComplete: 'Unable to complete lab request.',
        typeRequired: 'Type is required.',
        patientRequired: 'Patient is required.',
        resultRequiredToComplete: 'Result is required to complete.',
      },
    },
    lab: {
      code: 'Lab Code',
      status: 'Status',
      for: 'For',
      type: 'Type',
      result: 'Result',
      notes: 'Notes',
      requestedOn: 'Requested On',
      completedOn: 'Completed On',
      canceledOn: 'Canceled On',
      patient: 'Patient',
    },
  },
}
